import { getIn, useFormikContext } from 'formik';

import { AzureUpload } from 'components/azureUpload';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';
import { Revendedor } from 'pages/revendedor/revendedor/types';

export function RevendedorFilesBlock() {
    const { values, errors, setFieldValue } = useFormikContext<Revendedor>();

    return (
        <Block>
            <SubTitle label="Anexos" />

            <AzureUpload
                multipleUploads
                id="arquivo"
                files={
                    values.arquivo?.map((file) => ({
                        fgAtivo: true,
                        fgCapa: true,
                        fgExcluido: false,
                        fgNovo: false,
                        arquivo: file,
                    })) || []
                }
                onChange={(list) => {
                    const files = list.filter((file) => !file.fgExcluido);

                    setFieldValue(
                        'arquivo',
                        files.map((item) => item.arquivo),
                    );
                }}
                replaceFile={true}
                error={getIn(errors, 'arquivo')}
                accept={['.pdf', '.doc', '.docx']}
            />
        </Block>
    );
}
